module.exports = __webpack_public_path__ + "static/media/limpieza-&-spa.8c86983d.png";